import { parseDate as parse } from '../Utils/date'
import { findRule } from '../Utils'

const validate = vObj => {
  let value = vObj.value
  let rule = findRule(vObj.errorBag, 'date_format')
  let format = rule.ruleParams

  rule.feedback = `${
    vObj.fieldlabel
  } is required to be in ${format} format`

  return !!parse(value, format, new Date())
}

export { validate }

export default {
  validate
}
